module.exports = __webpack_public_path__ + "static/img/thumb_10.0e2ef86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_10.jpg
// module id = HNEU
// module chunks = 0